import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../../components/Button';

interface BranchListHeaderProps {
  total: number;
  onAdd: () => void;
}

const BranchListHeader: React.FC<BranchListHeaderProps> = ({ total, onAdd }) => {
  const { t } = useTranslation();

  return (
    <div className="col-md-12 header-section-div">
      <div className="row">
        <div className="col-sm-12 px-3 py-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <i className="ri-git-branch-line ri-22px"></i>
            <h5 className="mx-3 my-0">
              {t('stockists.addEdit.pageTexts.form.tabs.branches')} ({total})
            </h5>
          </div>
          <Button
            className="btn btn-primary"
            text={t('stockists.stockistBranch.list.pageTexts.header.addNewButton')}
            onClick={onAdd}
          />
        </div>
      </div>
    </div>
  );
};

export default BranchListHeader;
